/**
 * @title rxsearch.js: Sub-module for pharmacy search
 * @description This module is used to perform RX search actions
 * @dependency 
 */
define([], function() {	
	
	var rxsearch = {
			
		init : function() {
			rxsearch.initAlphabarEvents();
		},
		/**
		 * Initialize Alpha bar on change event, so that drug directory index is shown for selected letter
		 */
		initAlphabarEvents : function() {
			if ($('#browse-drug-select select').length == 1) {
				$('#browse-drug-select select').unbind('change').change(function () {
					
					if ($(this).val() != '') {
						window.location.href = $(this).val();
					}

				});
			}
		},
		/**
		 * Returns total number of search results.
		 * @return {number} Total number of search results.
		 */
		getTotalNumberOfResults: function() {
			return rxSearchResults ? rxSearchResults.drugResults.length : 0;
		},
		/**
		 * Creates search results section, for mobile and desktop display.
		 * 
		 * @param {number} currentPage Current page number.
		 * @param {number} itemsPerPage Number of displayed results per page.
		 * @param {string} displayBreak Display width at which two results columns break into four (expected 'lg' or 'xl')
		 * @param {string} resultsBlockId ID of the HTML element where results will be displayed.
		 * @param {string} pageStatsBlockClass HTML class of the element where page stats will be displayed.
		 * @param {string} paginationBlockId ID of the HTML element where page numbers will be displayed.
		 */
		createSearchResultsSection: function(currentPage, itemsPerPage, displayBreak, resultsBlockId, pageStatsBlockClass, paginationBlockId) {
			
			let pageSearchResults = this.getSearchResultsJSONForPage(currentPage, itemsPerPage);
			
			let $mobBlock = $('<div/>').html(COSTCO.util.tmpl('rx_search_results_wrapper_mobile_tmpl', {}));
			let $desktopBlock = $('<div/>').html(COSTCO.util.tmpl('rx_search_results_wrapper_desktop_tmpl', {}));
			
			let total = pageSearchResults.length;
			let mobStep = Math.floor((total + 1) / 2);
			let desktopStep = Math.floor((total + 3) / 4);
			
			let desktopSecondColumnStartIndex = 2 * desktopStep - (total % 4 == 1 ? 1 : 0);
			let desktopThirdColumnStartIndex = 3 * desktopStep - (total % 4 == 1 ? 2 : 0) - (total % 4 == 2 ? 1 : 0);
			
			$.each(pageSearchResults, function(index, value) {
				
				if (value.drugId === "") {
					value.drugId = 0;
				}
				
				let elementBlock = COSTCO.util.tmpl('rx_search_result_element_tmpl', value);

				// Handle Mobile
				if (index < mobStep) {
					$mobBlock.find('.rx-search-result-col:nth-of-type(1)').append(elementBlock);
					
				} else {
					$mobBlock.find('.rx-search-result-col:nth-of-type(2)').append(elementBlock);
				}

				// Handle Desktop
				if (index < desktopStep) {
					$desktopBlock.find('.rx-search-result-col:nth-of-type(1)').append(elementBlock);

				} else if (index < desktopSecondColumnStartIndex) {
					$desktopBlock.find('.rx-search-result-col:nth-of-type(2)').append(elementBlock);

				} else if (index < desktopThirdColumnStartIndex) {
					$desktopBlock.find('.rx-search-result-col:nth-of-type(3)').append(elementBlock);

				} else {
					$desktopBlock.find('.rx-search-result-col:nth-of-type(4)').append(elementBlock);
				}
			})
			
			switch (displayBreak) {
			case 'lg':
				$mobBlock.find('#results-wrapper-mobile').addClass('hidden-lg hidden-xl');
				$desktopBlock.find('#results-wrapper-desktop').addClass('hidden-xs hidden-sm hidden-md');
				break;
			case 'xl':
				$mobBlock.find('#results-wrapper-mobile').addClass('hidden-xl');
				$desktopBlock.find('#results-wrapper-desktop').addClass('hidden-xs hidden-sm hidden-md hidden-lg');
				break;
			default:
				$desktopBlock.find('#results-wrapper-desktop').addClass('hide');
				break;
			}

			$('#' + resultsBlockId).html($mobBlock.html());
			$('#' + resultsBlockId).append($desktopBlock.html());
			
			if (this.getTotalNumberOfResults() > 0) {
				this.updatePageStats(pageStatsBlockClass, currentPage, itemsPerPage, this.getTotalNumberOfResults());
			}
			
			if ($('#' + paginationBlockId).length) {
				this.createPagination(currentPage, itemsPerPage, displayBreak, resultsBlockId, pageStatsBlockClass, paginationBlockId);
			}
			$("#heading-search-item").focus();
		},
		/**
		 * Creates search results pagination.
		 * 
		 * @param {number} currentPage Current page number.
		 * @param {number} itemsPerPage Number of displayed results per page.
		 * @param {string} displayBreak Display width at which two results columns break into four (expected 'lg' or 'xl')
		 * @param {string} resultsBlockId ID of the HTML element where results will be displayed.
		 * @param {string} pageStatsBlockClass HTML class of the element where page stats will be displayed.
		 * @param {string} paginationBlockId ID of the HTML element where pagination will be displayed.
		 */
		createPagination: function(currentPage, itemsPerPage, displayBreak, resultsBlockId, pageStatsBlockClass, paginationBlockId) {
			
			let totalPages = parseInt((this.getTotalNumberOfResults() - 1) / itemsPerPage + 1);
			
			if ((totalPages > 1) && $('#' + paginationBlockId).length) {
				
				let $pagination = $('<ul/>');
				let templateId = 'rx_search_results_pagination_tmpl';
				let defaultPageJson = {
					'itemsPerPage': itemsPerPage,
					'displayBreak': displayBreak,
					'resultsBlockId': resultsBlockId,
					'pageStatsBlockClass': pageStatsBlockClass,
					'paginationBlockId': paginationBlockId
				}
				
				// Left arrow
				if (currentPage > 1) {
					$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, currentPage - 1, '', 'co-arrow-left')));
					$pagination.find('.co-arrow-left').parent('a').attr('aria-label', 'Previous Page');
				}
				
				// Display all page numbers, if number of pages less or equal to 5
				if (totalPages <= 5) {
					for (page = 1; page <= totalPages; page++) {
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, page)));
					}
				
				// Display page numbers and ellipses, if number of pages is greater than 5
				} else {
					
					// Calculate start and end page number to be displayed, relative to current page
					let startPage = currentPage - 1;
					let endPage = currentPage + 1; 
					
					if (startPage < 2) {
						startPage = 2;
						endPage = 4;
					} else if (endPage > totalPages - 2) {
						startPage = totalPages - 3;
						endPage = totalPages - 1;
					}
					
					// Page 1 - Always display
					$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, 1)));
					
					// Ellipsis
					if (startPage > 2) {
						$pagination.append(COSTCO.util.tmpl('rx_search_results_hellip_tmpl'));
					}
					
					// Display page numbers startPage-endPage
					for (page = startPage; page <= endPage; page++) {
						$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, page)));
					}
					
					// Ellipsis
					if (endPage < totalPages - 1) {
						$pagination.append(COSTCO.util.tmpl('rx_search_results_hellip_tmpl'));
					}
					
					// Last page - always display
					$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, totalPages)));
				}
				
				// Right arrow
				if (currentPage < totalPages) {
					$pagination.append(COSTCO.util.tmpl(templateId, this.createPageJson(defaultPageJson, currentPage + 1, '', 'co-arrow-right')));
					$pagination.find('.co-arrow-right').parent('a').attr('aria-label', 'Next Page');
				}
				
				// Mark current page active
				$pagination.find('#page-' + currentPage).addClass('btn-primary');
				
				$('#' + paginationBlockId).html($pagination);
				$pagination.find('#page-' + currentPage).attr('aria-current', 'page');
			}
		},
		/**
		 * Updates the page stats: the index of first and last record shown, and total number.
		 * 
		 * @param {string} pageStatsBlockClass HTML class of the element where page stats will be displayed.
		 * @param {number} currentPage Current page number.
		 * @param {number} itemsPerPage Number of displayed results per page.
		 * @param {number} total Total number of records.
		 */
		updatePageStats: function(pageStatsBlockClass, currentPage, itemsPerPage, total) {
			if ($('.' + pageStatsBlockClass).length) {
				let startItemIndex = 'undefined';
				let endItemIndex = 'undefined';
				if ((currentPage - 1) * itemsPerPage + 1 <= total) {
					startItemIndex = (currentPage - 1) * itemsPerPage + 1;
					endItemIndex = currentPage * itemsPerPage <= total ? currentPage * itemsPerPage : total;
				}
				$('.' + pageStatsBlockClass + ' .start-item-index').text(startItemIndex.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
				$('.' + pageStatsBlockClass + ' .end-item-index').text(endItemIndex.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
			}
		},
		/**
		 * Helper function used in rxsearch.createPagination().
		 * Creates JSON that represents page HTML element.
		 * 
		 * @param {Object} pageJson Page JSON with predefined fields.
		 * @param {number} page Page number.
		 * @param {string} pageText The text to be displayed, defaults to page.
		 * @param {string} pageClass HTML class of the page element.
		 * @return {Object} JSON that represents page HTML element.
		 */
		createPageJson: function(pageJson, page, pageText, pageClass) {
			if (pageJson.constructor === {}.constructor) {
				pageJson.page = page;
				pageJson.pageText = pageText != undefined ? pageText : page;
				pageJson.pageClass = pageClass != undefined ? pageClass : '';
			} else {
				console.error('Expected object as parameter.');
			}
			return pageJson;
		},
		/**
		 * Submit pharmacy-drug-detail-form and show drug details page
		 * 
		 * @param drugId
		 * @param drugName
		 */
		showDrugDetails : function(drugId, drugName) {
			let farmacyDrugDetailForm = $("#pharmacy-drug-detail-form");
			farmacyDrugDetailForm.find("input[name=drugId]").val(drugId);
			farmacyDrugDetailForm.find("input[name=drugName]").val(drugName);
			farmacyDrugDetailForm.find("input[name=encodedDrugName]").val(encodeURIComponent(drugName));

			farmacyDrugDetailForm.submit();			
		},
		/**
		 * Get JSON with search results, for given page.
		 * @param {number} pageNumber Page number.
		 * @param {number} itemsPerPage Number of displayed results per page.
		 * @return {array} JSON array with search results to be displayed on the current page.
		 */
		getSearchResultsJSONForPage : function(pageNumber, itemsPerPage) {
							
			let resultArray = [];
			
			if (this.getTotalNumberOfResults() > 0) {
			
				if (pageNumber == undefined) {		
					pageNumber = 1;
				}
				
				if (itemsPerPage == undefined) {
					itemsPerPage = 40;
				}
				
				let beginIndex = (pageNumber * itemsPerPage) - itemsPerPage;
				let endIndex = pageNumber * itemsPerPage - 1;
			
				$.each(rxSearchResults.drugResults, function(index, value) {
					if (beginIndex <= index && index <= endIndex) {
						resultArray.push(value);
					}
				});
			}
			
			return resultArray;
		},
	}	//end rxsearch object

	// Expose rxsearch to the global scope.
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.rxsearch = rxsearch;
		
	return rxsearch;
});



// WEBPACK FOOTER //
// ./js/rx/rxsearch.js